// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import requestAddresseeEntity from './entities/request-addressee.json';
import requestAddresseeMenu from '../pages/request-addressee/menu.json';
import requestAddresseeFullForm from '../pages/request-addressee/forms/full.json';
import requestAddresseeContextForm from '../pages/request-addressee/forms/context.json';
import requestAddresseeMiniForm from '../pages/request-addressee/forms/mini.json';
import requestAddresseeLookupForm from '../pages/request-addressee/forms/lookup.json';
import requestAddresseeTableView from '../pages/request-addressee/views/table.json';
import requestAddresseeCardsView from '../pages/request-addressee/views/cards.json';
import requestAddresseeDashboardView from '../pages/request-addressee/views/dashboard.json';

/** Тип запису «Адресат запиту» зі сторінками пакета: меню, форми та подання з pages/request-addressee/. */
export const requestAddresseeDefinition: IRecordTypeDefinition = {
  ...requestAddresseeEntity,
  views: assembleViewSet({
      table: requestAddresseeTableView,
      cards: requestAddresseeCardsView,
      dashboard: requestAddresseeDashboardView,
  }),
  form: requestAddresseeFullForm,
  forms: { full: requestAddresseeFullForm, context: requestAddresseeContextForm, mini: requestAddresseeMiniForm, lookup: requestAddresseeLookupForm },
  menu: requestAddresseeMenu,
} as IRecordTypeDefinition;
